import { render, staticRenderFns } from "./ChapterEvent.vue?vue&type=template&id=4f24ebe1&"
import script from "./ChapterEvent.vue?vue&type=script&lang=js&"
export * from "./ChapterEvent.vue?vue&type=script&lang=js&"
import style0 from "./ChapterEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports